export const ReferenceActionUnavailableReason = {
	ACL_EDITOR_REQUIRED: "ACL_EDITOR_REQUIRED",
	ACL_OWNER_REQUIRED: "ACL_OWNER_REQUIRED",
	LINKED_TO_PORTFOLIO: "LINKED_TO_PORTFOLIO",
	LEGACY_BENCHMARK: "LEGACY_BENCHMARK",
} as const;

export type ReferenceActionUnavailableReason =
	(typeof ReferenceActionUnavailableReason)[keyof typeof ReferenceActionUnavailableReason];

export const ReferenceListAction = {
	delete: "delete",
	share: "share",
	export: "export",
} as const;

export type ReferenceListAction = (typeof ReferenceListAction)[keyof typeof ReferenceListAction];
